import { GoToIcon } from 'assets/icons';
import {
  AboutIcon,
  BlogIcon,
  CommonDEFS,
  DeepFieldPQOIcon,
  DeepFieldSRIcon,
  EventIcon,
  PulsarAV1Icon,
  PulsarAVIFIcon,
  PulsarVQMIcon,
} from 'components/NewHeader/HeaderNavIcons';
import { GRAY30, GRAY50, GRAY60, H4KR, SubtitleM } from 'global-styles';
import { useContactModal } from 'hooks/useContactModal';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Dispatch, ReactNode, SetStateAction, useEffect } from 'react';
import styled from 'styled-components';

type LinkItem = { label: string; href: string; icon: ReactNode };

const companyItems: LinkItem[] = [
  { label: 'About', href: '/about', icon: <AboutIcon /> },
  { label: 'Blog', href: '/blog', icon: <BlogIcon /> },
  { label: 'Event', href: '/event', icon: <EventIcon /> },
];
const productItems: LinkItem[] = [
  {
    label: 'DeepField-SR',
    href: '/product/sr/#product-section',
    icon: <DeepFieldSRIcon />,
  },
  {
    label: 'DeepField-PQO',
    href: '/product/pqo/#product-section',
    icon: <DeepFieldPQOIcon />,
  },
  {
    label: 'Pulsar-AV1',
    href: '/product/av1/#product-section',
    icon: <PulsarAV1Icon />,
  },
  {
    label: 'Pulsar-AVIF',
    href: '/product/avif/#product-section',
    icon: <PulsarAVIFIcon />,
  },
  {
    label: 'Pulsar-VQM',
    href: '/product/vmaf/#product-section',
    icon: <PulsarVQMIcon />,
  },
];

type NavMobileAccordionProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const NavList = ({ setIsOpen }: NavMobileAccordionProps) => {
  const router = useRouter();
  const { handleMoveToContactUsPage } = useContactModal();

  useEffect(() => {
    const handleCloseIsOpenMobileNavMenu = () => {
      setIsOpen(false);
    };

    router.events.on('routeChangeComplete', handleCloseIsOpenMobileNavMenu);

    return () =>
      router.events.off('routeChangeComplete', handleCloseIsOpenMobileNavMenu);
  }, [router, setIsOpen]);

  return (
    <MobileNavAccordionContainer>
      <div className="link-list-wrapper">
        <H4KR>COMPANY</H4KR>
        <ul className="link-item-list">
          {companyItems.map(item => (
            <li className="link-item" key={item.href}>
              <div className="icon-wrapper">{item.icon}</div>
              {item.label === 'Contact' ? (
                <SubtitleM
                  as="a"
                  onClick={handleMoveToContactUsPage}
                  style={{ color: '#ccc', padding: '0' }}
                >
                  {item.label}
                </SubtitleM>
              ) : (
                <Link href={item.href}>
                  <SubtitleM as="a">{item.label}</SubtitleM>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="link-list-wrapper">
        <H4KR>PRODUCT</H4KR>

        <ul className="link-item-list">
          {productItems.map(item => (
            <li className="link-item" key={item.href}>
              <div className="icon-wrapper">{item.icon}</div>

              <Link href={item.href}>
                <SubtitleM as="a">{item.label}</SubtitleM>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <H4KR
        as="a"
        href="https://blue-dot.career.greetinghr.com/"
        target="_blank"
        rel="noreferrer"
        className="l-link-item link-list-wrapper"
      >
        CAREER
        <GoToIcon color={GRAY60} className="goto-icon" />
      </H4KR>

      <Link href="/product/avif#product-section">
        <H4KR as="a" className="l-link-item link-list-wrapper">
          Image Optimization
        </H4KR>
      </Link>

      <Link href="https://www.kokoon.cloud" target="_blank">
        <H4KR as="a" target="_blank" className="l-link-item link-list-wrapper">
          <span>Cloud</span>
          <GoToIcon color={GRAY60} className="goto-icon" />
        </H4KR>
      </Link>

      {/* svg 참조 컴포넌트 <defs> */}
      <CommonDEFS />
    </MobileNavAccordionContainer>
  );
};

const MobileNavAccordionContainer = styled.div`
  .link-item-list {
  }
  .link-item {
    display: flex;
    align-items: center;
    color: ${GRAY50};
    gap: 16px;
    padding-left: 32px;
  }
  .link-item:first-of-type {
    margin-top: 24px;
  }
  .l-link-item {
    color: ${GRAY30};
    align-items: center;
    display: flex;
    gap: 8px;
  }
  .l-link-item > svg {
    margin-left: 8px;
  }
  .link-item + .link-item {
    margin-top: 8px;
  }
  .link-list-wrapper {
    padding-block: 16px;
    display: block;
  }
  .icon-wrapper {
    width: 32px;
    height: 32px;
  }
`;
